export default __webpack_public_path__ + "static/media/arrow-left-disabled.88efda39.svg";